import {
  GET_ANALYTICS_REQUEST,
  GET_ANALYTICS_SUCCESS,
  GET_ANALYTICS_FAILED,
  GET_PERFORMANCE_REQUEST,
  GET_PERFORMANCE_SUCCESS,
  GET_PERFORMANCE_FAILED,
  GET_SALES_REQUEST,
  GET_SALES_SUCCESS,
  GET_SALES_FAILED,
  GET_ORDERCOUNT_REQUEST,
  GET_ORDERCOUNT_SUCCESS,
  GET_ORDERCOUNT_FAILED,
  DEFAULT_ERR,
} from '../types';

import { combineReducers } from 'redux';

const IntialState_1 = {
  loading: false,
  status: null,
  message: null,
  response: [],
  isError: false,
};

const IntialState_2 = {
  loading: false,
  status: null,
  message: null,
  response: {},
  isError: false,
};

const analytics = (state = IntialState_1, action) => {
  const { type, response: res, message } = action;
  switch (type) {
    case GET_ANALYTICS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_ANALYTICS_SUCCESS:
      return {
        ...state,
        status: res.status,
        response: res.response,
        loading: false,
        isError: false,
      };
    case GET_ANALYTICS_FAILED:
      return {
        ...state,
        message,
        loading: false,
        isError: true,
      };
    default:
      return state;
  }
};

const performance = (state = IntialState_2, action) => {
  const { type, response: res, message } = action;
  switch (type) {
    case GET_PERFORMANCE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_PERFORMANCE_SUCCESS:
      return {
        ...state,
        status: res.status,
        response: res.data,
        loading: false,
        isError: false,
      };
    case GET_PERFORMANCE_FAILED:
      return {
        ...state,
        message,
        loading: false,
        isError: true,
      };
    default:
      return state;
  }
};

const sales = (state = IntialState_1, action) => {
  const { type, response: res, err } = action;
  switch (type) {
    case GET_SALES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_SALES_SUCCESS:
      return {
        ...state,
        status: res.status,
        response: res.data,
        loading: false,
        isError: false,
      };
    case GET_SALES_FAILED:
      return {
        ...state,
        message: err.message,
        loading: false,
        isError: true,
      };
    default:
      return state;
  }
};

const orderCount = (state = IntialState_2, action) => {
  const { type, response: res, err } = action;
  switch (type) {
    case GET_ORDERCOUNT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_ORDERCOUNT_SUCCESS:
      return {
        ...state,
        status: res.status,
        response: res.data,
        loading: false,
        isError: false,
      };
    case GET_ORDERCOUNT_FAILED:
      return {
        ...state,
        message: err.message,
        loading: false,
        isError: true,
      };
    default:
      return state;
  }
};

const combinedDashboad = combineReducers({
  analytics,
  performance,
  sales,
  orderCount,
});
export default combinedDashboad;
